import QRCode from 'qrcode';
import { flightList, glyphs, pipes, travelerNotices } from 'helpers/airportData';

export const isPlanet = (id) => {
	return flightList.some(flight => flight.id === id && flight.planet);
};

export const isGlyphEasterEgg = (id) => {
	return glyphs.some(glyph => glyph.id === id && glyph.easterEgg);
};

export const isFlightEasterEgg = (id) => {
	return flightList.some(flight => flight.id === id && flight.easterEgg);
};

export const isTravelerNoticesEasterEgg = (id) => {
	return travelerNotices.some(notice => notice.id === id && notice.easterEgg);
};

export const goesToUpWorld = (id) => {
	return flightList.some(flight => flight.id === id && flight.upWorld);
};

export const getBlob = async (c) => new Promise((resolve, reject) => {
	if (!c) {
		reject(new Error('No canvas supplied'));
		return;
	}
	c.toBlob((blob) => {
		resolve(blob);
	});
});

export const loadImage = async (src) => new Promise((resolve, reject) => {
	if (!src) {
		reject(new Error('Image source is empty'));
		return;
	}
	let img = new Image();
	img.onload = () => resolve(img);
	img.onerror = () => reject(new Error(`Error loading image ${src}`));
	img.src = src;
});

export const generateQRCode = async (data) => {
	try {
		return await QRCode.toCanvas(data);
	} catch (error) {
		console.error('Error generating QR code:', error);
	}
};

export const pause = (duration) => new Promise((resolve) => setTimeout(resolve, duration));
